import React from 'react'

import { config } from 'lib/config'
import { GridContainer } from 'components/ui-kit'
import { SvgIcon } from 'components/icon'

import styles from './AppHeader.module.scss'

export const AppHeader = () => (
  <div className={styles.appHeader}>
    <GridContainer>
      <a href={`https://signup.${config.API_BASE_URL}/create-account`}>
        <SvgIcon name="logo" />
      </a>

      <a href={`https://${config.API_BASE_URL}/applicant`} className={styles.continueApplication}>
        <SvgIcon name="go-back-to" /> <span>Continue Existing Application</span>
      </a>
    </GridContainer>
  </div>
)
